import { PageError } from 'src/components/pages'

export default function Custom404() {
  return <PageError statusCode={404} />
}
